import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

import { CHECKBOX_RADIUS_PX } from 'theme/shape';

const CheckboxChecked = (props: SvgIconProps) => {
    return (
        <SvgIcon viewBox="0 0 18 18" sx={{ borderRadius: CHECKBOX_RADIUS_PX }} {...props}>
            <rect width="18" height="18" x="0" y="0" />
            <path fill="#fff" d="M15 6L7.5 13.5 3.5 9.5 5 8 7.5 10.5 13.5 4.5z" />
        </SvgIcon>
    );
};

export default CheckboxChecked;
